import { useState } from 'react';
import { Input, } from '../../../common/Forms/Input/Input';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  paymentType,
} from '../../../../assets/helpers/options';
import { OderCardHeader } from './OrderComponents';
import './OrderComponent.scss';

export const RCVCard = (props) => {
  const { label, card } = props;
  const { onChange } = card;
  const { register, errors, setValue, watch, control } = card.form;

  const [open, setOpen] = useState(true);



  const openPaymentModal = () => {
    setValue('billAmount', watch(`amount`));
    setValue('finalPrice', watch(`amount`));
    setValue('finalPriceInBsS', watch(`amountBsS`)); //Monto en Bs en base a euros

    setValue('paymentMethodsQuantity', 1);
    setValue('paymentType', paymentType?.DE_CONTADO);
    setValue('amount0', watch(`amount`));
    setValue('amountBsS0', watch('finalPriceInBsS')); //Monto en Bs en base a euros
  };

  const handlePaymentDateChange = () => {
    onChange?.getPaymentDateRate();
  };


  return (
    <>
      <div className="col-12">
        <div className="order-card">
          <OderCardHeader open={open} setOpen={setOpen} label={label} />

          {open && (
            <>
              <br />
              <div style={{ width: '100%' }} className="row">
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL PLAN
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Asesor'}
                      type={'select'}
                      options={card?.options?.sellerOptions}
                      name={'seller'}
                      register={register}
                      placeholder={''}
                      errors={errors?.seller?.message}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="row">
                    <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                    <h6 style={{ margin: '6px 12px 12px 0px' }}>
                      DATOS DEL PAGO
                    </h6>
                    <Input
                      bootstrap={'col-12'}
                      label={'Fecha de Pago *'}
                      type={'birthday'}
                      name={'paymentDate'}
                      register={register}
                      capitalizeOff={true}
                      placeholder={''}
                      control={control}
                      errors={errors?.paymentDate?.message}
                      onChange={() => handlePaymentDateChange()}
                    />
                    <>
                      <Input
                        bootstrap={'col-12 '}
                        label={`Monto USD * Tasa:${card.dollarRate} Bs`}
                        type={'number'}
                        name={'amount'}
                        register={register}
                        placeholder={''}
                        errors={errors?.amount?.message}
                        min={'0'}
                        disabled={true}
                      />
                      <Input
                        bootstrap={'col-12 '}
                        label={'Monto BsS *'}
                        type={'number'}
                        name={'amountBsS'}
                        register={register}
                        placeholder={''}
                        errors={errors?.amountBsS?.message}
                        disabled={true}
                      />
                      {watch('amount') &&
                        watch('amountBsS') &&
                        !watch('paymentMethodsQuantity') && (
                          <div className="buttons-center-container">
                            <ActionButton
                              label={'Pagar'}
                              action={() => openPaymentModal()}
                            />
                          </div>
                        )}
                    </>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
